
import debounce from 'lodash/debounce';
import anime from 'animejs';

const	gdprToggleItems = document.querySelectorAll('.js-gdpr-toggle');

[...gdprToggleItems].forEach( function ( gdprToggleItem ) {

	const 	input = gdprToggleItem.querySelector('.js-input'),
			gdprWrap = gdprToggleItem.querySelector('.js-gdpr-wrap'),
			gdprText = gdprToggleItem.querySelector('.js-gdpr-text');

	let 	gdprWrapInitialHeight = gdprText.offsetHeight + 20;

	input.addEventListener('focus', function () {

		anime({
			targets: gdprWrap,
			height: gdprWrapInitialHeight,
			easing: 'cubicBezier(0.250, 0.100, 0.250, 1.000)',
			duration: 300
		})

	})

	anime({
		targets: gdprWrap,
		height: 0,
		duration: 0
	})

	window.addEventListener('resize', debounce ( function () {

		// gdprWrapInitialHeight = gdprText.element.offsetHeight() + 20;

	}), 250)

})